import { withCompInfo } from '../../core/withCompInfo'
import { AddressInputDefinition, AddressInputProps, AddressInputCSSVars } from './types'

export const props = withCompInfo<AddressInputProps, AddressInputDefinition>(
	['compData', 'compProps', 'language'],
	({ compData, compProps, language }) => {
		return {
			placeholder: compData.placeholder,
			readOnly: compProps.readOnly,
			required: compProps.required,
			isDisabled: compProps.isDisabled,
			iconVisible: compProps.iconVisible,
			dividerVisible: compProps.dividerVisible,
			googleMapsApiKey: compData.googleMapsApiKey,
			country: compData.filter?.country,
			alignment: compProps.alignment,
			lang: language,
		}
	}
)

export const css = withCompInfo<AddressInputCSSVars, AddressInputDefinition>(
	['styleProperties'],
	({ styleProperties }) => {
		return { '--dropdownOptionPadding': `${styleProperties.dropdownOptionPadding}px` }
	}
)
